import $ from 'jquery';
import ko from 'knockout';

//Add a string format function like C# has.
//"Hello {0} {1}!".format("Jim", "Smith"); >> Hello Jim Smith!
String.prototype.format = function () {
  var stringValue = this;
  var i = arguments.length;

  while (i--) {
    stringValue = stringValue.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
  }
  return stringValue;
};

//Add a string replaceAll function. The built-in replace function only replaces the first instance.
String.prototype.replaceAll = function (search, replacement) {
  var target = this;

  if (typeof target !== "string")
    return "";

  return target.replace(new RegExp(search, 'g'), replacement);
};

//A knockout utility function that enhances the subscribe function with the addition of oldValue.
ko.subscribable.fn.subscribeChanged = function (callback) {
  var savedValue = this.peek();
  return this.subscribe(function (latestValue) {
    var oldValue = savedValue;
    savedValue = latestValue;
    callback(latestValue, oldValue);
  });
};

//Force a textbox to accept only numeric input.
$(document).on('keyup', '.numeric-input-only', function (event) {
  var v = this.value;
  if ($.isNumeric(v) === false) {
    //chop off the last char entered
    this.value = this.value.slice(0, -1);
  }
});